import { render, staticRenderFns } from "./UpgradePaymentQuota.vue?vue&type=template&id=409598c0&scoped=true&"
import script from "./UpgradePaymentQuota.vue?vue&type=script&lang=js&"
export * from "./UpgradePaymentQuota.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePaymentQuota.vue?vue&type=style&index=0&id=409598c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409598c0",
  null
  
)

/* custom blocks */
import block0 from "./UpgradePaymentQuota.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./UpgradePaymentQuota.vue?vue&type=custom&index=1&blockType=i18n&locale=en&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports